import { Link } from "../i18n";
import { MapPin, Phone, Clock } from "lucide-react";
import Logo from "./Logo";
import { useLang } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  const cats = ["cars", "vans", "trucks", "trailers", "forklifts"];

  return (
    <footer data-testid="site-footer" className="bg-[#07080C] border-t border-white/10 pt-16 pb-10 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <Logo />
              <span className="font-display font-extrabold tracking-[0.25em] text-lg text-slate-100">KATACO</span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs" data-testid="footer-tagline">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-slate-100 mb-5 text-sm tracking-widest uppercase">{t("footer.nav")}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-nav-home" to="/" className="hover:text-[#4499F7] transition-colors">{t("nav.home")}</Link></li>
              <li><Link data-testid="footer-nav-inventory" to="/inventory" className="hover:text-[#4499F7] transition-colors">{t("nav.inventory")}</Link></li>
              <li><Link data-testid="footer-nav-dismantling" to="/dismantling" className="hover:text-[#4499F7] transition-colors">{t("nav.dismantling")}</Link></li>
              <li><Link data-testid="footer-nav-machinery" to="/machinery" className="hover:text-[#4499F7] transition-colors">{t("nav.machinery")}</Link></li>
              <li><Link data-testid="footer-nav-about" to="/about" className="hover:text-[#4499F7] transition-colors">{t("nav.about")}</Link></li>
              <li><Link data-testid="footer-nav-contact" to="/contact" className="hover:text-[#4499F7] transition-colors">{t("nav.contact")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-slate-100 mb-5 text-sm tracking-widest uppercase">{t("footer.cats")}</h4>
            <ul className="space-y-3 text-sm">
              {cats.map((c) => (
                <li key={c}>
                  <Link data-testid={`footer-cat-${c}`} to={`/inventory?category=${c}`} className="hover:text-[#4499F7] transition-colors">
                    {t(`cats.${c}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-slate-100 mb-5 text-sm tracking-widest uppercase">{t("footer.contact")}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#4499F7] mt-0.5 shrink-0" />
                <span data-testid="footer-address">Șoseaua Unirii 185, Balotesti, Ilfov</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#4499F7] mt-0.5 shrink-0" />
                <span className="flex flex-col gap-1">
                  <a data-testid="footer-phone" href="tel:+40723250260" className="hover:text-[#4499F7] transition-colors">+40 723 250 260</a>
                  <a data-testid="footer-phone-2" href="tel:+40769229900" className="hover:text-[#4499F7] transition-colors">+40 769 229 900</a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-[#4499F7] mt-0.5 shrink-0" />
                <span data-testid="footer-hours">{t("contact.hoursVal")}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} KATACO. {t("footer.rights")}</span>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[#4499F7] transition-colors tracking-widest uppercase">
            {t("footer.adminLink")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
